import React from 'react'

function Search({ onHandleChange }) {
  return (
    <div className='d-flex flex-wrap align-items-center p-3 justify-content-evenly' style={{columnGap: "20px", rowGap: "10px"}}>
      <h4 className='color-secondary m-0'>Cari Kendaraan:</h4>
      <input 
        type="text" 
        name="search" 
        id="search" 
        className='w-75 rounded px-3 py-2'
        onChange={onHandleChange}
        placeholder="Avanza, Innova"
      />
    </div>
  )
}

export default Search